import i18next from 'i18next';
import type {
    DocumentApiHistory,
    IColorRGB,
    IDropdownOption,
    ILineEndings,
    ILineStyle,
    ILineWidth,
} from '../pdf/Interfaces';

export function borderStyleToDropdownOption(borderStyle: ILineStyle): IDropdownOption {
    return {
        key: borderStyle.name,
        text: borderStyle.name,
        data: borderStyle.icon,
    };
}

export function borderStylesToDropdownOptions(borderStyles: ILineStyle[]): IDropdownOption[] {
    return borderStyles.map(borderStyle => borderStyleToDropdownOption(borderStyle));
}

export function colorsToDropdownOptions(colors: IColorRGB[]): IDropdownOption[] {
    return colors.map(color => {
        return {
            key: color.code,
            text:
                colors.length === 1
                    ? i18next.t('colors.workflowColor')
                    : i18next.t(`colors.${color.name}`),
            data: color.name,
        } as IDropdownOption;
    });
}

export function documentHistoryToDropdownOptions(history: DocumentApiHistory[]): IDropdownOption[] {
    return history.map(h => {
        return {
            key: h.NoteId,
            text: h.docIndex,
            data: h.UniversalID,
        } as IDropdownOption;
    });
}

export function lineWidthToDropdownOption(lineWidth: ILineWidth): IDropdownOption {
    return {
        key: lineWidth.width,
        text: lineWidth.name,
        data: lineWidth.icon,
    };
}

export function lineWidthsToDropdownOptions(lineWidths: ILineWidth[]): IDropdownOption[] {
    return lineWidths.map(lineWidth => lineWidthToDropdownOption(lineWidth));
}

export function lineEndingToDropdownOption(lineEnding: ILineEndings): IDropdownOption {
    return {
        key: lineEnding.style,
        text: i18next.t('lineEndings.' + lineEnding.name),
        data: lineEnding.icon
    };
}

export function lineEndingsToDropdownOptions(lineEndings: ILineEndings[]): IDropdownOption[] {
    return lineEndings.map(lineEnding => lineEndingToDropdownOption(lineEnding));
}
